import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import * as M from "materialize-css/dist/js/materialize";
//import { AngularFireDatabase } from 'angularfire2/database';
import { AuthService, DataService, HelperService } from '../../_services';
@Component({
  selector: 'app-data-rehab',
  templateUrl: './data-rehab.component.html',
  styleUrls: ['./data-rehab.component.css'],
  //changeDetection: ChangeDetectionStrategy.Default
})
export class DataRehabComponent implements OnInit {

  constructor(
    private ngZone: NgZone,
    private changeDetector : ChangeDetectorRef,
    //public db: AngularFireDatabase,
    public svcAuth: AuthService,
    private svcData: DataService,
    private svcHelper: HelperService,
  ) { }
  
  pageData = {
    account: {
      fullName: '', email: 'admin', password: 'admin', confirmPassword: '', imageUrl: '', role: 'ADMIN', url: 'http://10.206.190.218:9000'
      //fullName: 'Geek', email: 'geek@gmail.com', password: 'pwd4Geek', confirmPassword: 'pwd4Geek', contactNo: '12345678', imageUrl: '', role: 'ADMIN', title: 'Manager'
    },
    viewMode: 'LIST',
    actionMode: 'NEW',
    userList: [],
  };
  tAccount:any;
  roles = [
    {title: 'Admin', value: 'ADMIN'},
    {title: 'Normal', value: 'NORMAL'},
  ];
  roleSelected: any;
  isLoading: false;
  ngOnInit() {
    this.dataLoad();
  }
  dataLoad(){
    this.loading(true);
    this.svcData.userList().subscribe(res=>{
      this.loading(false);
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.userList = res.data;
    });
  }
  dataLoadFirebase(){
    this.loading(true);
    //this.pageData.userList = [ {},{},{},{},{},{} ];
    // this.db.list('accounts').snapshotChanges().subscribe(res=>{
    //   this.loading(false);
    //   this.pageData.userList = [];
    //   res.forEach(resDetail=>{
    //     var _record:any = resDetail.payload.val();
    //     _record.key = resDetail.key;
    //     this.pageData.userList.push(_record);
    //   });
    // });
  }
  onSubmit(){
    var _hashPassword = this.svcHelper.hmac(this.pageData.account.password);
    //console.log(`Hash Passwod: ${_hashPassword}`);

    var _url = this.pageData.account.url + '/api/v1/login';
    var _arg = {
      'email': this.pageData.account.email,
      'password': _hashPassword
    };

    this.svcHelper.httpPost(_url, {}).subscribe(res=>{
      //console.log(res);
    });
    
  }
  loading(arg){
    var _self = this;
    this.ngZone.run(()=>{ _self.isLoading = arg; });
  }
  roleSelect(arg){
    this.roleSelected = arg;
  }
  showAlert(msg){
    //alert(msg);
    M.toast({html: msg});
  }
  userForm(arg){
    this.pageData.viewMode = 'FORM';
    this.pageData.actionMode = arg ? 'EDIT' : 'NEW';
    window.setTimeout(function(){
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
    }, 500);

    if(this.pageData.actionMode == 'EDIT'){
      this.tAccount = arg;
      this.pageData.account.fullName = arg.fullName;
      this.pageData.account.email = arg.email;
      this.roles.forEach(r=>{
        //console.log(r.value + ' vs ' + arg.role);
        if(r.value == arg.role){
          this.roleSelected = r;
          //(this.roleSelected);
        }
      });
    }
  }
  userDelete(arg){
    if(!confirm(`Are you sure you want to delete the user "${arg.fullName}"?`)) return;

    this.svcData.userDelete(arg).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.dataLoad();
      this.showAlert('User successfully deleted!');
    });
  }
  userList(){
    this.pageData.viewMode = 'LIST';
  }
  
}
